<template>
  <div class="level">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{ $t("m.jl_span0") }}</p>
    </div>
    <div class="level_con">
      <list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="getData"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          style="background-color: #ffffff; padding: 15px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #ebedf0;"
        >
          <div style="display: flex; align-items: center; width: 60%;">
            <icon
              name="gold-coin"
              style="margin-right: 10px"
              size="36"
              color="#FF1C40"
            />
            <div>
              <div style="margin-bottom: 5px" v-if="item.type === 1">
                银行卡提现
              </div>
              <div style="margin-bottom: 5px" v-else>USDT提现</div>
              <div style="margin-bottom: 5px">
                {{ $t("m.jf_span7") }}：{{ item.remark }}
              </div>
              <div style="margin-bottom: 5px">
                {{ $t("m.jl_span3") }}：{{ item.reply }}
              </div>
              <div style="color: #969799; font-size: 12px;">
                {{ createDate(item.created_at) }}
              </div>
            </div>
          </div>
          <div style="text-align: center">
            <div>{{ item.money }}{{ item.type == 1 ? "元" : "u" }}</div>
            <div>
              <span v-if="item.status === 0">{{ $t("m.jl_span4") }}</span>
              <span v-if="item.status === 1">{{ $t("m.jl_span5") }}</span>
              <span v-if="item.status === 2">{{ $t("m.jl_span6") }}</span>
              <span v-if="item.status === 3">{{ $t("m.jl_span7") }}</span>
            </div>
          </div>
        </div>
      </list>
    </div>
  </div>
</template>

<script>
import { getWithdraw } from "../../../api/user";
import Icon from "vant/lib/icon";
import List from "vant/lib/list";
import "vant/lib/list/style";
export default {
  name: "index",
  components: {
    Icon,
    List
  },
  data() {
    return {
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      show: false,
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  methods: {
    getData() {
      getWithdraw({ page: this.page }).then(res => {
        console.log(res.data.data);
        if (res.data.data.length > 0) {
          this.list = this.list.concat(res.data.data);
          this.page++;
        } else {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    }
  }
};
</script>

<style scoped>
.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: relative;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
}
.level_con {
  padding: 20px 15px;
}
</style>
